import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import GUI from "lil-gui";

/**
 * Loaders
 */
const gltfLoader = new GLTFLoader();
const cubeTextureLoader = new THREE.CubeTextureLoader();
const rgbeLoader = new RGBELoader();
const textureLoader = new THREE.TextureLoader();



/*
 * BASE
 */
// Debug
const gui = new GUI();
const global = {};

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();
// Set the scene background to a solid color.
// scene.background = new THREE.Color('#404040');
// Add fog to scene
// scene.fog = new THREE.Fog('#404040', 1, 15);

/**
 * Update all materials
 */

const updateAllMaterials = () => {
  scene.traverse((child) => {
    if (child.isMesh && child.material.isMeshStandardMaterial) {
      child.material.envMapIntensity = global.envMapIntensity;
    }
  });
};

/**
 * Environment map
 */
// const environmentMap = cubeTextureLoader.load([
//     './env/0/nx.png',
//     './env/0/nx.png',
//     './env/0/py.png',
//     './env/0/ny.png',
//     './env/0/pz.png',
//     './env/0/nz.png'
// ])
// scene.environment = environmentMap
// scene.background = environmentMap

// HDR (RGBE) equirectangular environment map
// rgbeLoader.load('./env/0/2k.hdr', (enviormentMap) =>
// {
//     enviormentMap.mapping = THREE.EquirectangularReflectionMapping
//     scene.background = enviormentMap
//     scene.environment = enviormentMap
// })

// Real time environment map

const environmentMap = textureLoader.load("./env/0/c.jpg");
environmentMap.mapping = THREE.EquirectangularReflectionMapping;
environmentMap.colorSpace = THREE.SRGBColorSpace;

scene.background = "#000";
const mainScreenMaterial = new THREE.MeshBasicMaterial({color: 0xFFFFe5})
// Holy donut
const holyDonut = new THREE.Mesh(
  new THREE.TorusGeometry(8, 0.5),
  new THREE.MeshBasicMaterial({ color: new THREE.Color(5, 4, 5) })
);
holyDonut.layers.enable(1);
holyDonut.position.y = 3.5;
scene.add(holyDonut);

// Cube render target
const cubeRenderTarget = new THREE.WebGLCubeRenderTarget(256, {
  type: THREE.FloatType,
});

scene.environment = cubeRenderTarget.texture;

// Cube camera
const cubeCamera = new THREE.CubeCamera(0.1, 100, cubeRenderTarget);
cubeCamera.layers.set(1);
// LDR equirectangular environment map
// const environmentMap = textureLoader.load('./env/0/u0.jpg')
// environmentMap.mapping = THREE.EquirectangularReflectionMapping

// scene.background = environmentMap
// scene.environment = environmentMap

// rgbeLoader.load('./env/0/u0.jpg', (environmentMap) =>
// {
//     environmentMap.mapping = THREE.EquirectangularReflectionMapping
//     scene.background = environmentMap

//     //skybox
//     const skybox = new GroundProjectedSkybox(environmentMap)
//     skybox.scale.setScalar(50)
//     scene.add(skybox)
// })

scene.backgroundIntensity = 0.5;
// scene.backgroundBlurriness = 0.1

//Global Intensity
global.envMapIntensity = 1;
gui
  .add(global, "envMapIntensity")
  .min(0)
  .max(10)
  .step(0.001)
  .onChange(updateAllMaterials);

/**
 * Models
 */

//Nukacola model

// gltfLoader.load("./model/nuka.glb", (gltf) => {
//   gltf.scene.position.y = 0; // Set the y coordinate of the entire model to 2
//   gltf.scene.traverse((child) => {
//     if (child.isMesh) {
//       child.castShadow = true; // Enable casting shadows
//       child.receiveShadow = true; // Enable receiving shadows
//     }
//   });
//   scene.add(gltf.scene);
// });
gltfLoader.load("./model/nuka.glb", (gltf) => {
  gltf.scene.scale.set(1, 1, 1);

  const mainScreenMesh = gltf.scene.children.find((child) => child.name === "mainscreen");
//   child.castShadow = true; // Enable casting shadows
//   child.receiveShadow = true; // Enable receiving shadows

  mainScreenMesh.material = mainScreenMaterial;
  gltf.scene.traverse((child) => {
    if (child.isMesh) {
        child.castShadow = true; // Enable casting shadows
        child.receiveShadow = true; // Enable receiving shadows
    }
    });
  scene.add(gltf.scene);
  updateAllMaterials();
});

// const gltfLoader = new GLTFLoader()

// gltfLoader.load(
//     '/models/FlightHelmet/glTF/FlightHelmet.gltf',
//     (gltf) =>
//     {

//       const children = [...gltf.scene.children]
//       for(const child of children){
//         scene.add(child)
//       }
//     }
// )

// const airplane = new GLTFLoader()

// airplane.load(
//     '/models/air/airplane.gltf',
//     (gltf) =>
//     {

//       const children = [...gltf.scene.children]
//       children[0].scale.set(0.1, 0.1, 0.1)
//       children[0].position.set(1, 1, 1)
//       children[0].castShadow = true

//       for(const child of children){
//         scene.add(child)
//       }
//     }
// )

// nuka cola old with materials per child
// const nukacola = new GLTFLoader();

// nukacola.load(
//     '/models/cola/nuka.gltf',
//     (gltf) =>
//     {
//       gltf.scene.position.y = 2; // Set the y coordinate of the entire model to 2

//       let childIndex = 0; // Initialize a counter to track the child index
//       gltf.scene.traverse((child) => {
//         if (child.isMesh) {
//           child.castShadow = true;
//           child.receiveShadow = true;

//           // Specific material settings for designated children
//           if (childIndex === 4) { // Apply red color to the fifth child
//             child.material = new THREE.MeshStandardMaterial({
//               color: '#B84F4D' // Red color
//             });
//           } else if (childIndex === 5) { // Apply white color to the sixth child
//             child.material = new THREE.MeshStandardMaterial({
//               color: '#FFFFFF' // White color
//             });
//           }
//           childIndex++; // Increment the index for each mesh
//         }
//       });

//       scene.add(gltf.scene); // Add the entire model to the scene
//     }
// );

/**
 * Plane floor
 */
// const floor = new THREE.Mesh(

//     new THREE.PlaneGeometry(10, 10),
//     new THREE.MeshStandardMaterial({
//         color: '#8D8D8D',
//         metalness: 0,
//         roughness: 0.5,
//         side: THREE.DoubleSide
//     })
// )
// floor.receiveShadow = true
// floor.rotation.x = - Math.PI * 0.5
// scene.add(floor)

/**
 * Plane floor with thickness
 */
const geometry = new THREE.BoxGeometry(10, 0.1, 10); // width, height (thickness), depth
const material = new THREE.MeshStandardMaterial({ color: "#4D4D4D" });
const thickPlane = new THREE.Mesh(geometry, material);

thickPlane.receiveShadow = true;
thickPlane.position.set(0, -2.09, 0); // Adjust position to align base with y = 0
scene.add(thickPlane);

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 2.4)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 1.8)
directionalLight.castShadow = true
// directionalLight.shadow.mapSize.set(1024, 1024)
// directionalLight.shadow.camera.far = 15
// directionalLight.shadow.camera.left = - 7
// directionalLight.shadow.camera.top = 7
// directionalLight.shadow.camera.right = 7
// directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(5, 5, 5)
// scene.add(directionalLight)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.set(0, 0, 6);
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.target.set(0, 0.75, 0);
// controls.enableDamping = true
// controls.minPolarAngle = Math.PI / 2; // Limit the vertical rotation
// controls.maxPolarAngle = Math.PI / 2; // Same here
controls.enableDamping = true; // Optional: for smoother drag interactions
// controls.dampingFactor = 0.05;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  //time
  const elapsedTime = clock.getElapsedTime();

  //Real time environment map
  if (holyDonut) {
    holyDonut.rotation.x = Math.sin(elapsedTime) * 2;
    cubeCamera.update(renderer, scene);
  }

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick(); // Configure your lighting, renderer, and any other settings as shown previously.
